import React from 'react'

export type NoticeRequiredProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const NoticeRequired: React.FC<NoticeRequiredProps> = (props) => {
  return (
    <div {...props} className={['form-input-input col-xs-12', props.className].filter((x) => !!x).join(' ')}>
      <span>{props.children}</span>
    </div>
  )
}

export default NoticeRequired
